import {
    instance as axios,
    setJwtToken,
  } from "../../config/axiosInstance";
  
export const memoriesListApi = async (data) => {
  const endPoint = `admin/memories/list?${new URLSearchParams(
    data
  ).toString()}`;
  return await axios.get(endPoint, setJwtToken());
};
